module.exports = __webpack_public_path__ + "img/scale_black.678033a6.svg";